import { getBackendApiUrl } from "@/lib/envConfig";

const LOCAL_DEV_BACKEND_PATTERN = /^http:\/\/(?:localhost|127\.0\.0\.1):8001\/api$/i;
const CLOUDFLARE_TUNNEL_PATTERN = /\.trycloudflare\.com$/i;

export function resolveBrowserBackendUrl(backendUrl, location) {
  if (
    !location ||
    !LOCAL_DEV_BACKEND_PATTERN.test(backendUrl) ||
    !CLOUDFLARE_TUNNEL_PATTERN.test(location.hostname)
  ) {
    return backendUrl;
  }

  return `${String(location.origin || "").replace(/\/+$/, "")}/api`;
}

const useBackendUrl = () => {
  const backendUrl = getBackendApiUrl();
  return resolveBrowserBackendUrl(
    backendUrl,
    typeof window === "undefined" ? null : window.location,
  );
};

export default useBackendUrl;
